import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appDecimalLimiter]'
})
export class DecimalLimiterDirective {

  @Input('appDecimalLimiter')
  decimalPlaces = 6;

  private regex: RegExp = new RegExp(`^\\d*\\.?\\d{0,${this.decimalPlaces}}$`);

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const value = inputElement.value;

    if (!value.match(this.regex)) {
      inputElement.value = value.slice(0, -1);
    }
  }
}
